module.exports = __webpack_public_path__ + "img/bunny_string_short.47f101cd.svg";